/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CarrierRestrictionDirection } from "./CarrierRestrictionDirection";
import {
  CarrierRestrictionDirectionFromJSON,
  CarrierRestrictionDirectionFromJSONTyped,
  CarrierRestrictionDirectionToJSON,
  CarrierRestrictionDirectionToJSONTyped,
} from "./CarrierRestrictionDirection";

/**
 *
 * @export
 * @interface CarrierQuotingRestrictionInput
 */
export interface CarrierQuotingRestrictionInput {
  /**
   *
   * @type {string}
   * @memberof CarrierQuotingRestrictionInput
   */
  carrierQuotingRestrictionId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CarrierQuotingRestrictionInput
   */
  carrierIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof CarrierQuotingRestrictionInput
   */
  name: string;
  /**
   *
   * @type {CarrierRestrictionDirection}
   * @memberof CarrierQuotingRestrictionInput
   */
  direction: CarrierRestrictionDirection;
  /**
   *
   * @type {Array<string>}
   * @memberof CarrierQuotingRestrictionInput
   */
  postalCodes: Array<string>;
}

/**
 * Check if a given object implements the CarrierQuotingRestrictionInput interface.
 */
export function instanceOfCarrierQuotingRestrictionInput(
  value: object,
): value is CarrierQuotingRestrictionInput {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("direction" in value) || value["direction"] === undefined) return false;
  if (!("postalCodes" in value) || value["postalCodes"] === undefined)
    return false;
  return true;
}

export function CarrierQuotingRestrictionInputFromJSON(
  json: any,
): CarrierQuotingRestrictionInput {
  return CarrierQuotingRestrictionInputFromJSONTyped(json, false);
}

export function CarrierQuotingRestrictionInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierQuotingRestrictionInput {
  if (json == null) {
    return json;
  }
  return {
    carrierQuotingRestrictionId:
      json["carrierQuotingRestrictionId"] == null
        ? undefined
        : json["carrierQuotingRestrictionId"],
    carrierIdentifier: json["carrierIdentifier"],
    name: json["name"],
    direction: CarrierRestrictionDirectionFromJSON(json["direction"]),
    postalCodes: json["postalCodes"],
  };
}

export function CarrierQuotingRestrictionInputToJSON(
  json: any,
): CarrierQuotingRestrictionInput {
  return CarrierQuotingRestrictionInputToJSONTyped(json, false);
}

export function CarrierQuotingRestrictionInputToJSONTyped(
  value?: CarrierQuotingRestrictionInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierQuotingRestrictionId: value["carrierQuotingRestrictionId"],
    carrierIdentifier: value["carrierIdentifier"],
    name: value["name"],
    direction: CarrierRestrictionDirectionToJSON(value["direction"]),
    postalCodes: value["postalCodes"],
  };
}
